import React, { ReactElement } from "react";

import { Container, Title, SubTitle, DarkBackground, Button, ButtonText } from "./styles";

import DotList from "~/components/DotList";

const items: ReactElement[] = [
  <span style={{ color: "white" }} key={1}>
    {"Learn what is required of your business to comply"}
  </span>,
  <span style={{ color: "white" }} key={2}>
    {"Show regulators your path towards compliance"}
  </span>,
  <span style={{ color: "white" }} key={3}>
    {"Fully automate incoming and outgoing transfers"}
  </span>,
];

export default function BookDemo() {
  return (
    <Container>
      <DarkBackground>
        <Title color={"#72e85f"}>Book a demo.</Title>
        <SubTitle color={"#fff"}>Comply with the Travel Rule at scale.</SubTitle>
        <DotList items={items} />
        <Button href="https://notabene.id/sign-up-for-notabene" target="_blank" rel="noreferrer">
          <ButtonText>BOOK A DEMO</ButtonText>
        </Button>
      </DarkBackground>
    </Container>
  );
}
